import { Box } from "@mui/material";
import React from "react";
import FilterAndSortButton from "./filterAndSortButton.tsx";
import SearchField from "../../../../../common/components/SearchField/searchField.tsx";
import { useSearchParams } from "react-router";

interface FilterAndSortButtonProps {
    handleClick: (event: React.MouseEvent<HTMLElement>, label: string) => void;
    handleSearchTicket: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>)=>void;
    searchValue:string;
    filterValue:string;   
    sortByOrder:string;
    sortByValue:string;
}

const MobFilters: React.FC<FilterAndSortButtonProps> = ({
    handleClick,
    handleSearchTicket,
    searchValue,
    filterValue,
    sortByOrder,
    sortByValue,
}) => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  return (

    <Box className="flex flex-col py-6 px-3 gap-4  md:hidden">
    <SearchField
      style={{ padding: "2px 0 2px", fontSize: "14px" }}
      sx={{ marginLeft: 1, flex: 1, padding: 0 }}
      handleSearchTicket={handleSearchTicket}
      placeHolder="Search Ticket"
      searchValue={searchValue}
    />

    <Box className="flex gap-4 ">
      <FilterAndSortButton
        handleClick={handleClick}
        filterValue={filterValue}
        sortByValue={sortByValue}
        sortByOrder={sortByOrder}
        sx={{
          color: "black",
          borderColor: "#D3D3DB",
          textTransform: "none",
          width: status==="active" ? "50%": "100%",
        }}
      />
    </Box>
  </Box>
  );
};

export default MobFilters;
